import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { SortDirection } from "@redotech/redo-views-common/table";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import {
  formatDateString,
  getExpandedItems,
} from "../../utils/outbound-labels-utils";

const productCustomDateKeys = [
  "productCustomDate1",
  "productCustomDate2",
  "productCustomDate3",
] as const;

export function ProductCustomDateColumn({
  title,
  key,
}: {
  title: string;
  key: (typeof productCustomDateKeys)[number];
}): Column2<FulfillmentGroupData> {
  return {
    alignment: ColumnAlignment.LEFT,
    key,
    title,
    renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
      // Collect values from all line items
      const values = new Set<string>();
      for (const item of getExpandedItems(row)) {
        const value = item[key];
        if (value) {
          values.add(formatDateString(value, true));
        }
      }

      return (
        <RedoTableTextCell
          text={values.size > 0 ? Array.from(values).join(", ") : ""}
        />
      );
    },
    renderExpandedCell: ({
      row,
      expansionIndex,
    }: {
      row: FulfillmentGroupData;
      expansionIndex: number;
    }) => {
      const lineItem = getExpandedItems(row)?.[expansionIndex];
      if (!lineItem) {
        return null;
      }
      const value = lineItem[key];
      return (
        <RedoTableTextCell text={value ? formatDateString(value, true) : ""} />
      );
    },
    width: 120,
    sort: SortDirection.DESC,
  };
}
